import {Box} from "@mui/system";
import React from "react";
import {getCurrencySymbol} from "../../../../../_helpers";
import {getAttributionMessage} from "../ProactiveMetricsDetailUtil";

export const SummaryCard = ({conversionOrders}) => {
    const monthsLapsed = conversionOrders?.emailSummary?.monthsLapsed
    const attributionText = getAttributionMessage(conversionOrders?.attributionHighlights)

    return(
        <Box sx={styles.wrapper}>
            <Box as={'p'} sx={{fontFamily: "FustatMedium", color: "#000000", fontSize: '14px'}}>
                {monthsLapsed === 0
                    ? "New customer acquisition"
                    : `Customer was ${conversionOrders?.emailSummary?.monthsLapsed} months lapsed`
                }
            </Box>
            <Box as={'p'} sx={{fontFamily: "FustatMedium", color: "#000000", fontSize: '14px', margin: 0}}>
                After Remarkable AI outreach customer placed order for a total of {" "}
                <Box as={'span'} sx={styles.total}>{getCurrencySymbol(conversionOrders.conversionOrderValue.currency)}{conversionOrders.conversionOrderValue.amount}</Box>
            </Box>

            {attributionText &&
                <Box as={'p'} sx={{fontFamily: "FustatMedium", color: "#000000", fontSize: '14px', margin: 0, marginTop: '10px'}}>
                    {attributionText}
                </Box>
            }
        </Box>
    )
}

const styles = {
    wrapper: {
        border: '1px solid #CED2D0',
        padding: '14px',
        borderRadius: '6px',
        marginBottom: '20px',
        backgroundColor: '#FFFFFF'
    },
    total: {
        fontFamily: "FustatMedium",
        fontWeight: "600",
        color: "#000000",
    }
}